// Simple helper to manage cookie consent across the app
const KEY = 'cookiesConsent';

// Values: 'accepted' | 'rejected' | 'unknown'

export function getConsent() {
  return localStorage.getItem(KEY) || 'unknown';
}

export function setConsent(value) {
  const normalized = value === 'accepted' ? 'accepted' : value === 'rejected' ? 'rejected' : 'unknown';
  localStorage.setItem(KEY, normalized);
  window.__cookieConsent = normalized;
  return normalized;
}

export function isOptionalAllowed() {
  return getConsent() === 'accepted';
}

export function resetConsent() {
  return setConsent('unknown');
}

// Initialize global flag on load (guarded for SSR)
if (typeof window !== 'undefined') {
  window.__cookieConsent = getConsent();
}

// Broadcast helper so components can react to consent changes if needed
export function onConsentChange(callback) {
  const handler = () => callback(getConsent());
  window.addEventListener('storage', handler);
  return () => window.removeEventListener('storage', handler);
}
